import React from 'react';
import { cn } from '../../lib/utils';
import { MenuCategory } from '../../lib/types';
interface MenuCategoryTabsProps {
  categories: MenuCategory[];
  activeCategory: string;
  onSelect: (categoryId: string) => void;
  primaryColor?: string;
}
export function MenuCategoryTabs({
  categories,
  activeCategory,
  onSelect,
  primaryColor // Ignored for styling, using fixed dark palette
}: MenuCategoryTabsProps) {
  if (!categories.length) return null;
  return <div className="sticky top-0 z-30 w-full bg-[#0B0B0B] border-b border-white/5 py-3" data-id="element-1848">
      <div className="max-w-3xl mx-auto" data-id="element-1849">
        <div className="flex overflow-x-auto hide-scrollbar px-4 sm:px-6" data-id="element-1850">
          <div className="flex gap-2 min-w-max" data-id="element-1851">
            {categories.map(category => {
            const isActive = activeCategory === category.id;
            return <button key={category.id} onClick={() => onSelect(category.id)} className={cn('px-5 py-2.5 text-sm font-semibold rounded-full transition-all whitespace-nowrap', isActive ? 'bg-[#F4D35E] text-[#0B0B0B] font-bold shadow-md shadow-[#F4D35E]/20' : 'bg-[#141414] text-[#F8F5F0]/60 hover:bg-[#1a1a1a] hover:text-[#F8F5F0]')} data-id="element-1852">
                  {category.name}
                </button>;
          })}
          </div>
        </div>
      </div>
    </div>;
}